<template>
  <div class="separator" />
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.separator {
  border: 1px solid $c-border-grey;
  width: 100%;
  height: 1px;
}
</style>
